import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Button } from '@mui/material'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined'
import {
  EVENT_CARD_ACTION_WIDTH,
  HOST_END_ICON_SIZE,
  hostEndButtonSx,
  joinButtonSx
} from './eventCardLayout'

/**
 * Right column: Join (primary) + optional host end control (bottom).
 * Grid rows keep spacing predictable — no flex space-between / nested wrappers.
 */
const EventCardActions = ({
  compact,
  joinTo,
  joinState,
  hostEnd,
  hostEndDisabled,
  onHostEnd
}) => {
  const actionWidth = compact ? EVENT_CARD_ACTION_WIDTH.narrow : EVENT_CARD_ACTION_WIDTH.wide
  const HostIcon = hostEnd?.icon === 'stop' ? StopCircleOutlinedIcon : CancelOutlinedIcon

  return (
    <Box
      component="aside"
      aria-label="Event actions"
      sx={{
        width: actionWidth,
        flexShrink: 0,
        alignSelf: 'stretch',
        display: 'grid',
        gridTemplateRows: hostEnd ? 'auto 1fr auto' : 'auto',
        justifyItems: 'stretch',
        alignItems: 'center'
      }}
    >
      <Button
        component={RouterLink}
        to={joinTo}
        state={joinState}
        variant="contained"
        size="medium"
        sx={{
          ...joinButtonSx(compact),
          gridRow: 1,
          alignSelf: 'start',
          mt: '6px'
        }}
      >
        Join
      </Button>

      {hostEnd ? (
        <Box
          component="button"
          type="button"
          disabled={hostEndDisabled}
          aria-label={hostEnd.ariaLabel}
          title={hostEnd.tone === 'close'
            ? 'End this live event for everyone'
            : 'Cancel this event before it goes live'}
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
            onHostEnd?.()
          }}
          sx={{
            ...hostEndButtonSx(hostEnd.tone),
            gridRow: 3,
            alignSelf: 'end',
            justifySelf: 'center'
          }}
        >
          <HostIcon sx={{ fontSize: HOST_END_ICON_SIZE }} />
          {hostEnd.actionLabel}
        </Box>
      ) : null}
    </Box>
  )
}

export default EventCardActions
